import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VideoService } from '../../../services/video/video.service';
import { environment } from '../../../../environments/environment';
import { configuration } from '../../../configuration/configuration';


@Component({
  selector: 'app-users-video-count',
  templateUrl: './users-video-count.component.html',
  styleUrls: ['./users-video-count.component.scss']
})
export class UsersVideoCountComponent implements OnInit {
  allUsersVideosCount: any[] = [];
  videoCount: any;

  isLoad = true;

  private API_URL = environment.API_URL;
  public PageSize = configuration.PAGESIZE;
  public PageNumber = configuration.PAGENUMBER;
  public pageSizes = configuration.PAGESIZES;
  selectedPageSize = this.pageSizes[0];
  searchQuery = '';
  list: any;
  totalItems: any;
  totalPages: any;
  isSearch = false;
  emptytable = false;
  direction = 'desc';
  sort = true; 

 
  column = '4';
  rotate = { 'asc': 'desc', 'desc': '', '': 'asc' };
  rotate2 = { asc: 'desc', desc: "", "": 'asc' };

  constructor(private toastr: ToastrService,
      private formBuilder: FormBuilder,
      private activatedRouter: ActivatedRoute,
      private router: Router,
      public vcRef: ViewContainerRef,
      private videoService: VideoService  ) { }

  ngOnInit(): void {
    this.activatedRouter.queryParamMap.subscribe((paramsVal) => {
      let tempPageNumber = paramsVal.get("PageNumber");
      let tempPageSize = paramsVal.get("PageSize");
      // let tempFilter = paramsVal.get("filterId");
      let tempSearch = paramsVal.get("SearchTerm");
      if (tempPageNumber !== undefined && tempPageNumber !== null) {
        this.PageNumber = Number(tempPageNumber);
      }
      if (tempPageSize !== undefined && tempPageSize !== null) {
        if (this.pageSizes.indexOf(Number(tempPageSize)) > -1) {
          this.PageSize = Number(tempPageSize);
        }
      }
      if (tempSearch !== undefined && tempSearch !== null) {
        this.searchQuery = tempSearch.toString();
      }
    })
    this.objmethod();      
    this.GetAllVideosCount();

  }

  objmethod() {
    let obj = {      
      PageNumber: this.PageNumber.toString(),
      PageSize: this.PageSize.toString(),
      SortBy: 'desc',
      sortColumn: '4',
      searchTerm: this.searchQuery.trim()
    }
    if (this.searchQuery) {
      obj['searchTerm'] = this.searchQuery.trim()
    }
    this.fetchData(obj);
  }
  fetchData(obj: any) {
    this.isLoad = true;
    this.videoService.GetAllUserMemoriesVideoCountListWithPagination(obj).subscribe((res: any) => {
      this.isLoad = false;
      this.list = res.list;
      this.PageSize = res.pageSize;
      this.PageNumber = res.pageNumber;
      this.totalItems = res.totalItems;
      this.totalPages = res.totalPages;
      this.searchQuery = res.searchTerm;
      this.isSearch = false;
      if (this.list.length == 0) {
        this.emptytable = true;
      } else {
        this.emptytable == false;
      }
    })
  }
// pagination starts
handlePageChange(event: any) { 
  this.PageNumber = event;
  this.router.navigate(["/videos/users-video-count"], {
    queryParams: {
      pageNumber: this.PageNumber,
      pageSize: this.PageSize,
      //filterId: this.filterId,
      SortBy: this.direction,
      SearchTerm: this.searchQuery.trim(),
    },
  });
  this.objmethod();
}
handlePageSizeChange(event: any) {
  this.PageSize = event.target.value;
  this.PageNumber = 1;
  this.router.navigate(["/videos/users-video-count"], {
    queryParams: {
      pageNumber: this.PageNumber,
      pageSize: this.PageSize,
      //filterId: this.filterId,
      SortBy: this.direction,
      SearchTerm: this.searchQuery.trim(),
    },
  });
  this.objmethod();
}
// pagination ends
// search starts
keyEvent(event: any) {
  this.searchQuery = (event.target.value).trim();
}
handleClear() {
  this.searchQuery = "";
  this.emptytable = false;
  // this.objmethod();
}
searchByValue(event: any) {
  this.isSearch = true;
  this.PageNumber = 1;
  this.router.navigate(["/videos/users-video-count"], {
    queryParams: {
      pageNumber: this.PageNumber,
      pageSize: this.PageSize,
      // filterId: this.filterId,
      SortBy: this.direction,
      searchTerm: this.searchQuery.trim(),
    },
  });
  this.objmethod();
}
GetAllVideosCount() {
  this.videoService.getAllVideosCount().subscribe((res: any) => {
    this.videoCount = res;     
  })
}  
}
